
export interface Entity {
    toJSON(): any;
    toNerEntities(type): any;
    nerEntityTypeOptions(): any[];
}
